// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/calendar-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/calendar-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/arrow-select.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/camera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/validation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/arrow-white-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/arrow-white-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("img/arrow-select.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("img/validation.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    outline: none !important;
}

#root {
    display: flex;
    min-height: 100vh;
}

img {
    max-width: 100%;
    height: auto;
    -webkit-user-select: none;
            user-select: none;
}

body {
    font-family: 'Inter', sans-serif;
    background-color: #fff;
    color: #1d253f;
}
@media (min-width: 576px) {
    body {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
}

a {
    text-decoration: none !important;
    transition: 0.3s;
    color: #1d253f;
}
a:hover {
    color: initial;
    opacity: 0.7;
}

.btn:focus {
    box-shadow: none;
}

.btn-block {
    width: 100%;
}

@media (min-width: 1400px) {
    .container {
        max-width: 1380px;
    }
}
@media (max-width: 575.98px) {
    .container {
        padding-left: 20px;
        padding-right: 20px;
    }
}

.row-6 {
    margin-left: -6px;
    margin-right: -6px;
}
.row-6 > [class*='col'] {
    padding-left: 6px;
    padding-right: 6px;
}

.row-8 {
    margin-left: -8px;
    margin-right: -8px;
}
.row-8 > [class*='col'] {
    padding-left: 8px;
    padding-right: 8px;
}

.row-10 {
    margin-left: -10px;
    margin-right: -10px;
}
.row-10 > [class*='col'] {
    padding-left: 10px;
    padding-right: 10px;
}

.form-group {
    margin-bottom: 16px;
}

.fz-0 {
    font-size: 0px !important;
}

.fz-14 {
    font-size: 14px !important;
}

.h1,
h1 {
    font-size: 56px;
    font-weight: 900;
}
@media (max-width: 767.98px) {
    .h1,
    h1 {
        font-size: 44px;
    }
}

.h1-comment {
    font-weight: bold;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.h3,
h3 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
    position: relative;
}
.h3 .number,
h3 .number {
    position: absolute;
    color: #6539d9;
    left: -25px;
}

.h3 .number.two-digit,
h3 .number.two-digit {
    left: -35px;
}

@media (max-width: 767.98px) {
    .h3 .number,
    h3 .number,
    h3 .number.two-digit {
        left: 0;
        top: -30px;
    }
}

.h4,
h4 {
    font-size: 16px;
    font-weight: bold;
}

.progress-line {
    background: #e1e5f0;
    height: 4px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    transition: 0.3s;
}
.progress-line:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #440fcf;
    width: 11%;
    transition: 0.3s;
}

.header {
    padding: 16px 0;
    margin-bottom: 24px;
    position: fixed;
    top: 4px;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 1030;
}
.header .logo img {
    width: 75px;
}
@media (max-width: 575.98px) {
    .header .logo img {
        width: 62px;
    }
}
.header .brand {
    display: inline-flex;
    font-weight: bold;
}
@media (max-width: 575.98px) {
    .header .brand {
        font-size: 14px;
    }
}
.header .brand img {
    width: 32px;
}

.main-section {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    z-index: 1002;
}

.steps {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1030;
}
.steps .step-1 {
    display: flex;
}
.steps > [class*='step'] {
    flex-direction: column;
    flex-grow: 1;
}

.main-content {
    padding: 260px 0 120px;
}
@media (min-width: 1980px) {
    .main-content {
        margin-top: auto;
        margin-bottom: auto;
    }
}

.likely-box {
    display: flex;
    margin-bottom: 48px;
}
/* @media (max-width: 767.98px) {
    .likely-box {
        justify-content: center;
    }
} */
.likely-box .radio-group {
    display: inline-block;
    font-size: 14px;
    position: relative;
}
@media (min-width: 768px) {
    .likely-box .radio-group:not(:last-child) {
        margin-right: 18px;
    }
}
@media (max-width: 575.98px) {
    .likely-box .radio-group {
        flex-grow: 1;
    }
}
.likely-box .radio-group input {
    display: none;
}
.likely-box .radio-group input ~ span {
    padding: 4px;
    display: inline-block;
    width: 36px;
    height: 36px;
    border: 1px solid #6539d9;
    border-radius: 8px;
    text-align: center;
    line-height: 28px;
    color: #6539d9;
    cursor: pointer;
}
@media (max-width: 767.98px) {
    .likely-box .radio-group input ~ span {
        border-radius: 0;
    }
}
@media (max-width: 575.98px) {
    .likely-box .radio-group input ~ span {
        width: 100%;
        padding: 2px;
        font-size: 12px;
    }
}
.likely-box .radio-group input:checked ~ span,
.likely-box .radio-group input:hover ~ span {
    transition: 0.3s;
    background: #6539d9;
    font-weight: bold;
    color: #fff;
}
@media (max-width: 767.98px) {
    .likely-box .radio-group:first-child span {
        border-radius: 6px 0 0 6px;
    }
    .likely-box .radio-group:last-child span {
        border-radius: 0 6px 6px 0;
    }
    .likely-box .radio-group:not(:last-child) span {
        border-right: 0;
    }
}

.likely-link {
    position: absolute;
    bottom: -36px;
    cursor: pointer;
    white-space: nowrap;
    color: #4e5778;
}
.likely-link.link-right {
    right: 0;
}

.footer {
    margin-top: 24px;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 20px 0 48px;
    text-align: center;
    background: #fff;
    z-index: 2;
}
@media (max-width: 991.98px) {
    .footer {
        padding: 20px 0;
    }
}

.pagination-box {
    font-size: 14px;
}
.pagination-box .arrows-box {
    display: inline-block;
    vertical-align: middle;
}
.pagination-box .arrows-box .arrow {
    display: inline-block;
    background: #fff;
    border-radius: 8px;
    width: 24px;
    height: 24px;
    text-align: center;
    padding: 4px;
    background: #fff;
    border: 1px solid #af91ff;
    transition: 0.3s;
    line-height: 14px;
}
.pagination-box .arrows-box .arrow:hover {
    background: #440fcf;
    opacity: 1;
}
.pagination-box .arrows-box .arrow:hover svg path {
    fill: #fff;
}
.pagination-box .arrows-box .arrow:disabled {
    opacity: 0.6;
    pointer-events: none;
}

.btn-next {
    color: #fff;
    background: #6539d9;
    border: 0;
    padding: 10px 34px;
    transition: 0.3s;
    font-size: 14px;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
}
@media (max-width: 575.98px) {
    .btn-next {
        width: 100%;
    }
}
.btn-next:hover,
.btn-next:active {
    opacity: 1;
    color: #fff !important;
    background: #440fcf !important;
}
.btn-next:disabled {
    background: #c4c9d9 !important;
    color: rgba(255, 255, 255, 0.6) !important;
}
.btn-next.audio-to-text {
    padding: 10px 16px;
    line-height: 22px;
}
.btn-next.audio-to-text svg path {
    fill: #fff !important;
}
.btn-next.delete-image-btn {
    padding: 10px 16px;
}
.btn-next.btn-cancel {
    padding: 10px 16px;
    border: 1px solid #6539d9;
    background: #fff;
    color: #1d253f;
    font-weight: normal;
}
.btn-next.btn-cancel:hover {
    opacity: 1;
    color: #fff !important;
    background: #440fcf !important;
}

.btn-prev {
    border: 1px solid #af91ff;
    padding: 7.5px;
    transition: 0.3s;
    border-radius: 8px;
    width: 41px;
    height: 41px;
    line-height: 24px;
    text-align: center;
    font-size: 0;
}
.btn-prev:hover,
.btn-prev:active,
.btn-video:active,
.btn-video:hover {
    opacity: 1;
    color: #fff !important;
    border-color: #440fcf !important;
    background: #440fcf !important;
}
.btn-prev:hover svg path,
.btn-prev:active svg path {
    fill: #fff;
}
.btn-video {
    border: 1px solid #af91ff;
    padding: 5px 7.5px 5.5px 7.5px;
    transition: 0.3s;
    border-radius: 8px;
    width: auto;
    height: inherit;
    line-height: 24px;
    text-align: center;
    margin-top: 10px;
    background-color: transparent;
}

.copywright {
    font-size: 14px;
    color: #4e5778;
}
@media (max-width: 575.98px) {
    .copywright {
        font-size: 12px;
    }
}
.copywright .link-brand {
    color: #440fcf;
}

.form-textarea {
    height: 220px !important;
    resize: none;
    background: #fff;
    border-radius: 8px;
    color: #1d253f;
    border: 1px solid #838bad;
    font-size: 14px;
    padding: 12px 16px 40px;
}
.form-textarea::-webkit-input-placeholder {
    color: #838bad;
}
.form-textarea::-moz-placeholder {
    color: #838bad;
}
.form-textarea:-ms-input-placeholder {
    color: #838bad;
}
.form-textarea:focus {
    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);
    border-color: #838bad;
}

.generated {
    font-size: 12px;
    color: #838bad;
    position: absolute;
    bottom: 12px;
    left: 16px;
}
.generated img,
.generated span {
    vertical-align: middle;
}

.the-count-1000 {
    position: absolute;
    color: #c4c9d9;
    bottom: 12px;
    right: 16px;
    display: inline-block;
    font-size: 12px;
    transition: 0.3s;
}

.the-count-100 {
    color: #4e5778;
    font-size: 12px;
    text-align: right;
    position: absolute;
    right: 0;
    top: 44px;
}

.label-store {
    margin-bottom: 14px;
    font-size: 14px;
    color: #4e5778;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 2px;
}

.label-agreement {
    color: #1d253f;
}

input[type='checkbox'],
input[type='radio'] {
    display: none;
}
input[type='checkbox'] ~ .f,
input[type='radio'] ~ .f {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    border: 1px solid #838bad;
    border-radius: 100px;
    position: relative;
}
input[type='checkbox']:checked ~ .f,
input[type='radio']:checked ~ .f {
    transition: 0.3s;
    background: #6539d9;
    border-color: #6539d9;
    color: #6539d9;
}
input[type='checkbox']:checked ~ .f:before,
input[type='radio']:checked ~ .f:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
input[type='checkbox']:checked ~ .f ~ span,
input[type='radio']:checked ~ .f ~ span {
    font-weight: bold;
}

input[type='radio']:checked ~ .f:before {
    width: 7px;
    height: 7px;
    background: #fff;
    border-radius: 100px;
}

input[type='checkbox'] ~ .f {
    border-radius: 4px;
}
input[type='checkbox']:checked ~ .f:before {
    width: 16px;
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center center;
    background-repeat: no-repeat;
}

.input-text {
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid #838bad;
    border-radius: 8px;
    height: 40px;
    color: #1d253f;
}
.input-text::-webkit-input-placeholder {
    color: #7c85a6;
}
.input-text::-moz-placeholder {
    color: #7c85a6;
}
.input-text:-ms-input-placeholder {
    color: #7c85a6;
}
.input-text:focus {
    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);
    border-color: #838bad;
}
.input-text.error {
    border-color: #ff3e4a;
}

.label {
    font-size: 12px;
    color: #838bad;
    margin-bottom: 8px;
}

@media (min-width: 576px) {
    .input-small {
        max-width: 280px;
    }
}

.datepicker {
    padding: 8px 16px 8px 30px;
    cursor: pointer;
}
.datepicker:focus ~ svg path {
    fill: #1d253f;
}

.img-calendar {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
    pointer-events: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.title-feedback {
    font-weight: 900;
    font-size: 56px;
    color: #1d253f;
    line-height: 1.2;
}
@media (max-width: 767.98px) {
    .title-feedback {
        font-size: 32px;
        text-align: center;
    }
}

@media (max-width: 767.98px) {
    .feedback-box {
        text-align: center;
    }
}

.ui-widget {
    font-family: inherit;
}
.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
    font-family: inherit;
}

.ui-widget-content {
    border-color: #838bad !important;
    border-radius: 8px;
    padding: 16px;
    min-width: 280px;
}
@media (max-width: 575.98px) {
    .ui-widget-content {
        width: calc(100% - 40px);
    }
}

.ui-datepicker .ui-state-default {
    font-size: 14px;
    background: none;
    border: none;
}
.ui-datepicker .ui-state-default:hover {
    color: #fff !important;
    background-color: #6539d9;
    font-weight: bold;
    opacity: 1;
}
.ui-datepicker td span,
.ui-datepicker td a {
    width: 30px;
    height: 30px;
    padding: 0;
    line-height: 30px;
    border-radius: 5px;
    text-align: center;
}
.ui-datepicker .ui-state-active {
    color: #fff !important;
    background-color: #6539d9;
    font-weight: bold;
    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);
}
.ui-datepicker .ui-state-highlight {
    color: #1d253f !important;
    background-color: #fff;
    border: 1px solid #6539d9;
    font-weight: bold;
}
.ui-datepicker .ui-datepicker-buttonpane {
    margin: 0;
}
.ui-datepicker .ui-datepicker-buttonpane button {
    margin: 0.5em 0.2em;
    padding: 0.2em 0.3em;
    transition: 0.3s;
}
.ui-datepicker .ui-datepicker-title {
    line-height: inherit;
}
.ui-datepicker .ui-datepicker-title select {
    appearance: none;
    font-size: 14px;
    margin: 1px 0;
    font-weight: bold;
    border: 0;
    height: 26px;
    padding: 1px 10px;
    cursor: pointer;
    width: auto;
    line-height: 1;
    background-position: calc(100% - 7px) center;
    background-size: 7px;
}
.ui-datepicker .ui-datepicker-title select::-ms-expand {
    display: none;
}

.ui-datepicker-header {
    border: none;
    border-radius: 0;
    background: none;
}

.ui-datepicker-calendar thead th {
    color: #838bad !important;
    font-weight: normal !important;
}

.ui-datepicker-prev,
.ui-datepicker-next {
    top: 50% !important;
    transform: translateY(-50%);
    border: none !important;
    background: none !important;
    cursor: pointer;
}
.ui-datepicker-prev span,
.ui-datepicker-next span {
    background: none !important;
    font-size: 12px;
    transition: 0.3s;
    width: 6px;
    height: 10px;
    margin: 0 !important;
    transform: translate(-50%, -50%) !important;
}
.ui-datepicker-prev span:before,
.ui-datepicker-next span:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}

.ui-datepicker-prev span:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.ui-datepicker-prev:hover span {
    transform: translateX(-2px);
}

.ui-datepicker-next span:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.ui-datepicker-next:hover span {
    transform: translateX(2px);
}

.select2-container {
    display: block;
    width: auto !important;
    min-width: 140px !important;
}
@media (min-width: 576px) {
    .select2-container {
        max-width: 280px !important;
    }
}
.select2-container .select2-selection--single {
    background: #fff;
    border: 1px solid #838bad;
    padding-left: 16px;
    padding-right: 26px;
    transition: 0.3s;
    height: 40px;
}
.select2-container .select2-selection--single:focus {
    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);
}
.select2-container .select2-selection--single .select2-selection__rendered {
    padding-left: 0;
    padding-right: 0;
}
.select2-container .selection {
    display: block;
}

.select2-container--default .select2-selection--single {
    border-radius: 8px !important;
}
.select2-container--default
    .select2-selection--single
    .select2-selection__rendered,
.select2-container--default
    .select2-selection--single
    .select2-selection__placeholder {
    color: #1d253f;
    line-height: 38px;
    font-size: 14px;
}
.select2-container--default
    .select2-selection--single
    .select2-selection__clear {
    display: none;
}
.select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    height: 5px;
    width: 8px;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
}
.select2-container--default
    .select2-selection--single
    .select2-selection__arrow
    b {
    display: none;
}

.select2-container--open .select2-dropdown {
    border: 1px solid #838bad;
    border-radius: 8px;
    overflow: hidden;
    top: 16px;
    padding: 0;
}
.select2-container--open .select2-dropdown .select2-search--dropdown {
    display: none;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options {
    max-height: 100px;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 2px;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options::-webkit-scrollbar-thumb {
    background-color: #f2edff;
    border-radius: 2px;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options
    .select2-results__option {
    font-size: 14px;
    padding: 4px 16px;
    color: #4e5778;
    background-color: transparent;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options
    .select2-results__option--highlighted.select2-results__option--selectable {
    background: transparent;
}
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options
    .select2-results__option--highlighted.select2-results__option--selectable:hover,
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options
    .select2-results__option--highlighted.select2-results__option--selectable.select2-results__option--selected,
.select2-container--open
    .select2-dropdown
    .select2-results
    .select2-results__options
    .select2-results__option--highlighted.select2-results__option--selectable.select2-results__option--highlighted.select2-results__option--selectable {
    background-color: #f2edff;
}

.step-2,
.step-3,
.step-4,
.step-5,
.step-6,
.step-7,
.step-8,
.step-9 {
    display: none;
}

.step-2-active .progress-line:before {
    width: 22.2222222222%;
}
.step-2-active .steps .step-1 {
    display: none;
}
.step-2-active .steps .step-2 {
    display: flex;
}

.step-3-active .progress-line:before {
    width: 33.3333333333%;
}
.step-3-active .steps .step-2 {
    display: none;
}
.step-3-active .steps .step-3 {
    display: flex;
}

.step-4-active .progress-line:before {
    width: 44.4444444444%;
}
.step-4-active .steps .step-3 {
    display: none;
}
.step-4-active .steps .step-4 {
    display: flex;
}

.step-5-active .progress-line:before {
    width: 55.5555555556%;
}
.step-5-active .steps .step-4 {
    display: none;
}
.step-5-active .steps .step-5 {
    display: flex;
}

.step-6-active .progress-line:before {
    width: 66.6666666667%;
}
.step-6-active .steps .step-5 {
    display: none;
}
.step-6-active .steps .step-6 {
    display: flex;
}

.step-7-active .progress-line:before {
    width: 77.7777777778%;
}
.step-7-active .steps .step-6 {
    display: none;
}
.step-7-active .steps .step-7 {
    display: flex;
}

.step-8-active .progress-line:before {
    width: 88.8888888889%;
}
.step-8-active .steps .step-7 {
    display: none;
}
.step-8-active .steps .step-8 {
    display: flex;
}

.step-9-active .progress-line:before {
    width: 100%;
}
.step-9-active .steps .step-8 {
    display: none;
}
.step-9-active .steps .step-9 {
    display: flex;
}

.textarea-box .message {
    text-align: center;
    background: #ede7fb;
    border-radius: 100px;
    font-size: 10px;
    padding: 4px 16px;
    margin-bottom: 16px;
}
.textarea-box .message.orange {
    background: #ffebdc;
}
.textarea-box .message.red {
    background: #ffdcdc;
}

.dropdown-media .dropdown-toggle {
    display: inline-block;
    border: 1px solid #6539d9;
    border-radius: 8px;
    padding: 8px 16px;
    height: 42px;
    font-size: 14px;
    line-height: 22px;
    background: #fff;
}
.dropdown-media .dropdown-toggle svg path {
    transition: 0.3s;
}
.dropdown-media .dropdown-toggle:hover {
    opacity: 1;
    color: #fff !important;
    background: #440fcf !important;
}
.dropdown-media .dropdown-toggle:hover svg path {
    fill: #fff;
}
.dropdown-media .dropdown-toggle:after {
    display: none;
}
.dropdown-media .dropdown-toggle.show {
    background: #ede7fb;
}
.dropdown-media .dropdown-menu {
    margin-top: 0;
    min-width: 100%;
    border-color: #838bad;
    border-radius: 8px;
}
.dropdown-media .dropdown-menu .dropdown-item {
    padding: 4px 16px;
    color: #4e5778;
    font-size: 14px;
}
.dropdown-media .dropdown-menu .dropdown-item:hover,
.dropdown-media .dropdown-menu .dropdown-item:active,
.dropdown-media .dropdown-menu .dropdown-item:focus {
    background-color: #f4f4f5;
    opacity: 1;
}

.audio-recording {
    background: #ede7fb;
    border-radius: 8px;
    padding: 12.5px 16px 12.5px 35px;
    box-sizing: border-box;
}
.audio-recording.orange #recordTimeDisplay .limit {
    color: #ff6b00;
}
.audio-recording.red #recordTimeDisplay .limit {
    color: #ff3e4a;
}

@media (min-width: 576px) {
    .audiorecorder > [class*='col']:first-child {
        border-right: 1px solid #e1e5f0;
    }
    .audiorecorder > [class*='col']:last-child {
        border-left: 1px solid #e1e5f0;
    }
}

.btn-delete svg path,
.btn-transform svg path {
    transition: 0.3s;
}
.btn-delete:hover,
.btn-transform:hover {
    opacity: 1;
}
.btn-delete:hover svg path,
.btn-transform:hover svg path {
    fill: #6539d9;
}

.btn-record,
.btn-play,
.btn-transform,
.btn-empty-audio,
.btn-delete {
    /* width: 20px;
    height: 20px; */
    display: inline-block;
    text-align: center;
    line-height: 20px;
    font-size: 0;
    width: auto;
    height: auto;
    border: none;
    background: none;
}

.btn-transform:disabled {
    opacity: 0.5;
}

#waveform {
    cursor: pointer;
}

#recordTimeDisplay,
#playTimeDisplay {
    font-size: 14px;
}
#recordTimeDisplay span,
#playTimeDisplay span {
    font-weight: bold !important;
}

.range {
    width: 100%;
    height: 10px;
    -webkit-appearance: none;
    background: #c4c9d9;
    outline: none;
    border-radius: 15px;
    overflow: hidden;
    pointer-events: none;
}

.range::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #f2edff;
    box-shadow: -407px 0 0 400px #440fcf;
}

/* @media (max-width: 575.98px) {
    .modal-audio.fade .modal-dialog {
        transform: translate(0, 100%);
    }
    .modal-audio.show .modal-dialog {
        transform: translate(0, 0);
    }
    .modal-audio .modal-dialog {
        margin: auto 0 0 0;
        min-height: 100vh;
    }
} */
.modal-audio .modal-content {
    padding: 40px;
    text-align: center;
    border: 0;
}
/* @media (max-width: 575.98px) {
    .modal-audio .modal-content {
        border-radius: 8px 8px 0 0;
        margin-top: auto;
    }
} */
.modal-audio .modal-content .icon-box {
    display: flex;
    position: relative;
    width: 150px;
    height: 150px;
    margin: 0 auto;
    margin-bottom: 40px;
}
.modal-audio .modal-content .icon-box .icon-box-inside {
    margin: auto;
    width: 100px;
    height: 100px;
    line-height: 100px;
    background: #f2edff;
    border-radius: 100px;
    position: relative;
    z-index: 3;
}
.modal-audio .modal-content .icon-box .icon-box-inside:before,
.modal-audio .modal-content .icon-box .icon-box-inside:after {
    content: '';
    position: absolute;
    border-radius: 100px;
    transition: 0.3s;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.modal-audio .modal-content .icon-box .icon-box-inside:before {
    width: 160px;
    height: 160px;
    background: rgba(242, 237, 255, 0.6);
    z-index: -1;
    animation: color-point 5s infinite;
}
.modal-audio .modal-content .icon-box .icon-box-inside:after {
    width: 200px;
    height: 200px;
    background: rgba(242, 237, 255, 0.4);
    z-index: 1;
    animation: color-point 5s infinite;
}

@keyframes color-point {
    0% {
        opacity: 0;
    }
    33% {
        opacity: 0.5;
    }
    50% {
        opacity: 1;
    }
    75% {
        opacity: 0.5;
    }
    100% {
        opacity: 0;
    }
}
.video-recording,
.video-outer {
    position: relative;
}

.video-outer {
    border: 1px solid #c4c9d9;
    overflow: hidden;
    border-radius: 8px;
    box-sizing: border-box;
    display: block;
}

.video-outer .video-delete {
    z-index: 22;
}

.video-recording .video-js {
    /* background: #f2edff; */
    /* border: 1px solid #c4c9d9; */
    /* overflow: hidden; */
    width: 100%;
    height: inherit;
}
.video-recording .video-js .vjs-device-button {
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 48px;
    height: 48px;
    margin: 0;
    transform: translate(-50%, -50%);
}
.video-recording .video-js .vjs-device-button:before {
    display: none;
}
.video-recording .video-js .vjs-device-button:hover {
    opacity: 0.8;
}
.video-recording .video-js .vjs-control-bar {
    color: #af91ff;
    height: auto;
    background: #fff;
}

@media (min-width: 576px) {
    .video-recording .video-js .vjs-control-bar {
        padding: 16px;
        font-size: 12px;
    }
}
.video-recording .video-js .vjs-control-bar button {
    transition: 0.3s;
}
.video-recording .video-js .vjs-control-bar button:hover {
    color: #440fcf;
}
.video-recording
    .video-js
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control
    .vjs-volume-level {
    background: #440fcf;
}
.video-recording .video-js .vjs-control-bar .vjs-current-time,
.video-recording .video-js .vjs-control-bar .vjs-time-divider,
.video-recording .video-js .vjs-control-bar .vjs-duration {
    padding-left: 2px;
    padding-right: 2px;
    min-width: auto;
}
.video-recording .video-js .vjs-control-bar .vjs-play-progress {
    background: #440fcf;
}

.video-delete,
.upload__img-delete,
.upload__img-play {
    position: absolute;
    top: 12px;
    left: 12px;
    background: #fff;
    border-radius: 100px;
    width: 28px;
    height: 28px;
    border: 1px solid #c4c9d9;
    text-align: center;
    line-height: 23px;
    cursor: pointer;
}
.video-delete svg path,
.upload__img-delete svg path,
.upload__img-play svg path {
    transition: 0.3s;
}
.video-delete:hover svg path,
.upload__img-delete:hover svg path,
.upload__img-play:hover svg path {
    fill: #440fcf;
}

label.error {
    color: #ff3e4a;
    font-size: 12px;
    padding-left: 20px;
    padding-right: 40px;
    position: relative;
}
label.error:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 16px;
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: center center;
    background-repeat: no-repeat;
}

.images-uploading .upload__box .upload__btn-box {
    border: 1px solid #838bad;
    border-radius: 8px;
    text-align: center;
    overflow: hidden;
}
.images-uploading .upload__box .upload__btn-box .upload__inputfile {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
}
.images-uploading .upload__box .upload__btn-box .upload__btn {
    position: relative;
    transition: 0.3s;
}
.images-uploading .upload__box .upload__btn-box .upload__btn:hover {
    opacity: 0.8;
}
.images-uploading .upload__box .upload__btn-box .upload__btn .upload-img {
    padding: 10px;
    display: flex;
    height: 110px;
}
.images-uploading .upload__box .upload__btn-box .upload__btn .upload-img img {
    margin: auto;
}
.images-uploading .upload__box .upload__img-box {
    flex: 0 0 auto;
    width: 33.33333333%;
    padding: 0 10px;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
    order: -1 !important;
}
@media (max-width: 575.98px) {
    .images-uploading .upload__box .upload__img-box {
        width: 50%;
    }
}
@media (min-width: 1200px) {
    .images-uploading .upload__box .upload__img-box:hover .upload__img-delete,
    .images-uploading .upload__box .upload__img-box:hover .upload__img-play {
        opacity: 1;
        pointer-events: initial;
    }
    .images-uploading
        .upload__box
        .upload__img-box:hover
        .magnific-popup:after {
        opacity: 1;
    }
}
@media (max-width: 1199.98px) {
    .images-uploading .upload__box .upload__img-box .upload__img-bottom {
        background: #ede7fb;
        height: 36px;
        border-radius: 0 0 8px 8px;
    }
}
.images-uploading .upload__box .upload__img-box .magnific-popup {
    height: 110px;
    position: relative;
    display: block;
    border-radius: 8px;
    border: 1px solid #838bad;
    overflow: hidden;
}
@media (max-width: 1199.98px) {
    .images-uploading .upload__box .upload__img-box .magnific-popup {
        border-radius: 8px 8px 0 0;
    }
}
.images-uploading .upload__box .upload__img-box .magnific-popup:after {
    content: '';
    position: absolute;
    transition: 0.3s;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(101, 57, 217, 0.5);
    opacity: 0;
}
.images-uploading .upload__box .upload__img-box .magnific-popup:hover {
    opacity: 1;
}
.images-uploading .upload__box .upload__img-box .magnific-popup .img-bg {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.images-uploading .upload__box .upload__img-box .upload__img-delete,
.images-uploading .upload__box .upload__img-box .upload__img-play {
    top: auto;
    bottom: 4px;
    transition: 0.3s;
}
@media (min-width: 1200px) {
    .images-uploading .upload__box .upload__img-box .upload__img-delete,
    .images-uploading .upload__box .upload__img-box .upload__img-play {
        opacity: 0;
        pointer-events: none;
        top: 50%;
        bottom: auto;
        transform: translateY(-50%);
    }
    .images-uploading .upload__box .upload__img-box .upload__img-delete:hover,
    .images-uploading .upload__box .upload__img-box .upload__img-play:hover {
        opacity: 1;
        pointer-events: initial;
    }
}
.images-uploading .upload__box .upload__img-box .upload__img-delete {
    left: 16px;
}
.images-uploading .upload__box .upload__img-box .upload__img-play {
    right: 16px;
    left: auto;
}

.mfp-bg {
    background: #1d253f;
}

.mfp-container {
    width: 40%;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
@media (max-width: 575.98px) {
    .mfp-container {
        width: 100%;
    }
}
.mfp-container .mfp-arrow {
    background-position: center center;
    background-repeat: no-repeat;
    margin-top: 0;
    width: 24px;
    height: 24px;
    transition: 0.3s;
    top: auto;
    bottom: 16px;
}
.mfp-container .mfp-arrow:before,
.mfp-container .mfp-arrow:after {
    display: none !important;
}
.mfp-container .mfp-arrow.mfp-arrow-right {
    right: 24px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@media (max-width: 575.98px) {
    .mfp-container .mfp-arrow.mfp-arrow-right {
        right: 22px;
    }
}
.mfp-container .mfp-arrow.mfp-arrow-left {
    left: auto;
    right: 60px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@media (max-width: 575.98px) {
    .mfp-container .mfp-arrow.mfp-arrow-left {
        right: 48px;
    }
}
.mfp-container .mfp-content {
    border-radius: 8px;
}
.mfp-container .mfp-content .mfp-figure:after {
    top: 0;
    border-radius: 8px;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 2;
    background: linear-gradient(
        to bottom,
        #030303 0%,
        transparent 30%,
        transparent 70%,
        #030303 100%
    );
}
.mfp-container .mfp-content .mfp-img {
    padding: 0;
    border-radius: 8px;
}
.mfp-container .mfp-content .mfp-close {
    right: 16px;
    padding: 3px;
    color: #fff;
    transition: 0.3s;
    cursor: pointer !important;
    width: auto;
}
.mfp-container .mfp-content .mfp-bottom-bar {
    bottom: 0;
    z-index: 3;
}
.mfp-container .mfp-content .mfp-bottom-bar .mfp-counter {
    left: 24px;
    right: auto;
    font-size: 14px;
    color: #fff;
}

/* @media (max-width: 575.98px) {
    .modal-delete.fade .modal-dialog {
        transform: translate(0, 100%);
    }
    .modal-delete.show .modal-dialog {
        transform: translate(0, 0);
    }
    .modal-delete .modal-dialog {
        margin: auto 0 0 0;
        min-height: 100vh;
    }
} */
.modal-delete .modal-content {
    padding: 32px;
    text-align: center;
    border: 0;
}
/* @media (max-width: 575.98px) {
    .modal-delete .modal-content {
        border-radius: 8px 8px 0 0;
        margin-top: auto;
        padding: 32px 20px 40px;
    }
} */
.modal-delete .modal-content .icon-box {
    display: flex;
    border-radius: 100px;
    background: #ede7fb;
    padding: 28px;
    width: 120px;
    height: 120px;
    margin: 0 auto 20px;
}

.text-capital {
    text-transform: capitalize;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.progress-line .progress {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #440fcf;
    transition: all 0.3s ease 0s;
}
.arrow-gap {
    margin-right: 5px;
}
.que-num-gap {
    margin-right: 4px;
}
/* .btn-record {
	width: auto;
    height: auto;
	border: none;
    background: none;
} */
.btn-record,
.stop-record,
.btn-empty-audio,
.btn-delete {
    cursor: pointer;
}
.video-recording .vjs-control-bar {
    min-height: 68px !important;
    /* border: 1px solid #c4c9d9; */
    border-radius: 0 0 8px 8px;
    border-top: 0;
}

.video-preview {
    /* border-radius: 8px; */
    width: 100%;
    height: inherit;
    /* border: 1px solid #c4c9d9; */
    overflow: hidden;
}

.vjs-control-bar button {
    background: none;
    border: none;
    outline: none;
}

.vjs-control-bar button.start-video,
.vjs-control-bar button.stop-video,
.vjs-control-bar button.play-video {
    width: 48px;
    cursor: default;
    text-align: left;
}

.stop-video-icon,
.start-video-icon {
    width: 14px;
    height: 14px;
    background-color: rgb(68, 15, 207, 0.5);
    cursor: pointer;
    display: inline-block;
}

.switch-camera svg g {
    fill: rgb(68, 15, 207, 0.5);
}

.stop-video-icon:hover,
.start-video-icon:hover {
    background-color: rgb(68, 15, 207, 1);
}

.start-video-icon {
    border-radius: 100%;
}

.video-preview video {
    width: 100%;
    height: 100%;
    display: block;
}

.step-btn-bottom {
    position: fixed;
    bottom: 52px;
}
.select-input {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    background-position: center right 12px;
    background-size: 8px;
}
.form-control {
    font-size: 14px;
    color: #1d253f;
}
.error-message {
    color: #ff3e4a;
    font-size: 12px;
    position: relative;
    padding-left: 20px;
    font-weight: 400;
    margin-top: 5px;
}

.error-message.textarea-validation {
    margin-top: 0;
    left: 16px;
    display: inline-block;
    bottom: 12px;
    position: absolute;
}

.error-message::before {
    content: '';
    position: absolute;
    left: 0;
    top: -1px;
    width: 16px;
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-position: center center;
    background-repeat: no-repeat;
}
.img-bg img {
    width: 100%;
}
.modal.show {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
}
.contact-step {
    position: absolute;
    left: -35px !important;
}
.contact-form label {
    font-size: 12px;
    color: #838bad;
    margin-bottom: 8px;
    width: 100%;
}
.contact-form label span.agree-policy {
    font-size: 14px;
    color: #1d253f;
    position: relative;
    top: 2px;
    padding-left: 5px;
    width: calc(100% - 25px);
}
.image-gallery {
    background-color: #000;
}

.image-gallery-slide img {
    border: 2px solid #fff;
    border-radius: 8px;
}

.image-gallery-slide::after {
    content: '';
    display: block;
    width: auto;
    height: auto;
    /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.6); */
    top: 0;
    border-radius: 8px;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 2;
    /* background: linear-gradient(to bottom, #030303 0%, transparent 30%, transparent 70%, #030303 100%); */
}

/*# sourceMappingURL=style.css.map */

.thumbnail-list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.thumbnail-list img {
    width: 100px;
    height: 100px;
    object-fit: cover;
}

.gallery-wrapper {
    position: relative;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
    z-index: 10;
}
.image-gallery {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1043;
    position: fixed;
    outline: none !important;
    -webkit-backface-visibility: hidden;
    overflow: hidden auto;
    background-color: rgb(29, 37, 63, 0.8);
}
.image-gallery-content {
    max-width: 40%;
    min-width: 100px;
    width: auto;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    position: absolute;
    padding: 0 8px;
    box-sizing: border-box;
}
.image-gallery-slide img {
    border: 0px;
    width: inherit !important;
}
.image-gallery .image-gallery-icon {
    background-position: center center;
    background-repeat: no-repeat;
    margin-top: 0;
    width: 24px;
    height: 24px;
    transition: 0.3s;
    top: auto;
    bottom: 0;
    padding: 0;
    background-color: #222;
}
.image-gallery .image-gallery-left-nav {
    left: auto;
    right: 48px;
}
.image-gallery .image-gallery-right-nav {
    right: 15px;
}
.image-gallery-left-nav .image-gallery-svg,
.image-gallery-right-nav .image-gallery-svg {
    width: 24px;
    height: 24px;
}
.image-gallery-slide {
    border-radius: 8px;
    overflow: hidden;
}
.image-gallery .close-button {
    right: 15px;
    top: 15px;
    padding: 3px;
    color: #fff;
    transition: 0.3s;
    cursor: pointer !important;
    width: auto;
    background: #222;
    font-size: 21px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-gallery-icon:hover {
    color: #fff;
}

@media screen and (max-width: 767px) {
    .contact-step {
        left: 0 !important;
    }
    .image-gallery-content {
        max-width: 60%;
    }
}

.audio-recording .audio-recorder {
    background-color: transparent;
    box-shadow: none;
    border-radius: 0px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.audio-recording .audio-recorder-mic,
.audio-recording .audio-recorder-options {
    padding-top: 0;
    padding-bottom: 0;
}
.audio-recording .audio-recorder-mic {
    order: 1;
}
.audio-recording img[data-testid='ar_pause'].audio-recorder-options {
    padding-right: 0;
    display: none;
}
.audio-recording img[data-testid='ar_cancel'].audio-recorder-options {
    padding-right: 0;
    width: 22px;
    display: none;
}
.outer-audio .btn-delete {
    border: 0;
    padding: 0;
    background-color: transparent;
}
.outer-audio .audio-creating {
    position: relative;
}
.audio-creating .btn-delete {
    position: absolute;
    top: 10px;
    left: 16px;
}
.audio-recorder-svg-color {
    filter: invert(15%) sepia(85%) saturate(4708%) hue-rotate(257deg)
        brightness(76%) contrast(120%);
}
.audio-recorder-svg-color-red {
    filter: invert(18%) sepia(96%) saturate(7500%) hue-rotate(1deg)
        brightness(105%) contrast(114%);
    padding-right: 0;
}
.audio-recorder-svg-color-red.mic {
    position: relative;
    right: 32px;
    pointer-events: none;
    filter: invert(30%) sepia(6%) saturate(6%) hue-rotate(337deg)
        brightness(101%) contrast(87%);
    cursor: not-allowed;
    padding-left: 0;
    border-radius: 0px;
    opacity: 0;
}

.preview-title {
    font-size: 18px;
    margin: 10px 0;
}
.inner-preview {
    width: calc(100% - 115px);
    margin-left: 8px;
    position: absolute;
    top: 4px;
    height: 33px;
}
.outer-audio .sendSpeech {
    border: 0;
    position: absolute;
    right: 20px;
    top: 10px;
    background-color: transparent;
    width: 24px;
    padding-right: 0;
}
audio::-webkit-media-controls-panel,
audio::-webkit-media-controls-enclosure,
audio::-webkit-media-controls-play-button,
audio,
audio::-webkit-media-controls-rewind-button,
audio::-webkit-media-controls-return-to-realtime-button {
    background-color: transparent !important;
}

audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-pause-button,
audio::-webkit-media-controls-mute-button,
audio::-webkit-media-controls-volume-slider-container,
audio::-webkit-media-controls-volume-slider,
audio::-webkit-media-controls-current-time-display,
audio::-webkit-media-controls-time-remaining-display,
audio::-webkit-media-controls-timeline {
    filter: invert(15%) sepia(85%) saturate(4708%) hue-rotate(257deg)
        brightness(76%) contrast(120%);
    box-shadow: none !important;
    text-shadow: none !important;
}

form.main-form-new {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
.contact-form span.agree-policy,
.contact-form span.agree-policy a {
    font-weight: 400 !important;
}

.data-policy {
    color: #6539d9;
}

@media (max-width: 768px) {
    input,
    textarea,
    select {
        font-size: 16px !important;
    }
    .myVideo-dimensions {
        width: 100%;
        max-width: 100%;
        min-height: 250px;
        height: 0;
        padding-top: 56.25%;
    }
}

.loader {
    width: 75px;
    aspect-ratio: 1;
    border: 8px solid #ddd;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.loader::before {
    content: '';
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    border: 8px solid #440fcf;
    animation: loader 2s infinite linear;
}
@keyframes loader {
    0% {
        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
        clip-path: polygon(
            50% 50%,
            0 0,
            100% 0,
            100% 100%,
            100% 100%,
            100% 100%
        );
    }
    75% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
}
.overlay-loader {
    position: fixed;
    top: 0;
    left: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.2);
}
.outer-loader {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -30px;
    width: 100%;
    height: 100%;
}

@-moz-document url-prefix() {
    .range {
        -webkit-appearance: auto;
    }
}
.media-attached {
    font-size: 12px;
    color: #4e5778;
    margin-top: 5px;
    text-align: center;
    padding: 0 12px;
}

.speech-controller {
    position: absolute;
    width: calc(100% - 2px);
    bottom: 1px;
    left: 1px;
    z-index: 2;
    background: #fff;
    height: 40px;
    border-radius: 0 0 8px 8px;
}
.label-store.label-agreement .align-middle {
    position: relative;
    top: 2px;
}

.question-header {
    position: fixed;
    top: 60px;
    width: 100%;
    left: 0;
    background-color: #fff;
    z-index: 1030;
}
.row.flex-grow-1 {
    align-items: flex-start;
}

.mobile-question-head {
    padding-top: 115px;
}

video.vjs-tech {
    width: 100%;
}
.vjs-control-bar {
    padding: 16px;
    font-size: 12px;
    color: #af91ff;
    height: auto;
    background: #fff;
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.left-icons {
    display: flex;
}

.play-video-icon {
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-left: 12px solid rgb(68, 15, 207, 0.5);
    border-bottom: 7px solid transparent;
    cursor: pointer;
    position: relative;
    top: -1px;
}

.play-video-icon:hover {
    border-left-color: #440fcf;
}

.switch-camera {
    display: none;
}
button.full-screen:hover svg path {
    fill: #440fcf;
}
.vjs-record-indicator {
    width: 8px;
    height: 8px;
    background-color: #ff625e;
    border-radius: 50%;
    right: 2.5ex;
    top: 2ex;
    position: absolute;
    opacity: 1;
    transform: rotateX(0) scale(1.3);
    transition:
        all 0.5s,
        transform 0.2s 0.1s;
}
.vjs-record-indicator::before {
    content: 'REC';
    color: #fff;
    position: absolute;
    left: -2.7em;
    font-family: Helvetica, sans-serif;
    animation-name: pulsetext;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    top: -0.1em;
    font-size: 8px;
    opacity: 0.6;
    transition: opacity 0.5s 0.2s;
}

.vjs-record-indicator::after {
    content: '';
    display: block;
    height: calc(0.8em - 4px);
    width: calc(0.8em - 4px);
    border: 2px solid #ff625e;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: center;
    animation-name: pulse;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: 0.25s;
}

.vjs-record-indicator:hover::before {
    text-shadow: 0 0 1em #fff;
}

.vjs-control-bar.h-68 {
    height: 68px;
}

.right-icons {
    display: flex;
    align-items: center;
}

.video-controls {
    display: flex;
    align-items: center;
}

.volume-icon {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    margin-right: 10px;
}

.play-controls svg path {
    fill: rgb(68, 15, 207, 0.5);
}
.play-controls svg:hover path {
    fill: rgb(68, 15, 207, 1);
}
.play-controls {
    display: flex;
    align-items: center;
    margin-right: 15px;
}

.volume-range {
    width: 80px;
    height: 5px;
}

.timer {
    display: flex;
    align-items: center;
}

@media (max-width: 1024px) {
    .switch-camera {
        display: block;
    }
}
@media (max-width: 844px) {
    .volume-range {
        width: 48px;
    }
    .left-icons button.start-video,
    .left-icons button.stop-video,
    .left-icons button.play-video {
        width: 35px;
    }
}

.btn-border {
    border: 1px solid #af91ff !important;
    border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI;;;QAGI,OAAO;QACP,UAAU;IACd;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;;;GAIG;AACH;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,OAAO;IACP,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;;IAEI,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;;;;IAII,UAAU;IACV,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;AAClC;AACA;;IAEI,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AACA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;AACA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yDAAuC;IACvC,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;AACxB;AACA;;;;IAII,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gDAAgD;AACpD;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IAGI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,cAAc;IACd,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;AACnB;AACA;;IAEI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;AAC/C;AACA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,yDAA+C;AACnD;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yDAAgD;AACpD;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,gDAAgD;AACpD;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;AACA;;;;;;IAMI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;AACA;;;IAGI,aAAa;AACjB;AACA;;;IAGI,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,yDAA8C;IAC9C,sBAAsB;AAC1B;AACA;;;;IAII,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;;;;IAII,iBAAiB;AACrB;AACA;;;;IAII,UAAU;IACV,WAAW;AACf;AACA;;;;IAII,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;;;;IAII,yBAAyB;IACzB,kBAAkB;AACtB;AACA;;;;;IAKI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;AACA;;;;;IAKI,uBAAuB;AAC3B;AACA;;;;;;;;;;;;;;;IAeI,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;;;IAGI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,+BAA+B;IACnC;IACA;QACI,8BAA8B;IAClC;AACJ;;AAEA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,aAAa;AACjB;;AAEA;;;;;IAKI;mBACe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;AACA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;;;;;;;;;;;GAWG;AACH;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;AACA;;;;;GAKG;AACH;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;AACd;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,kCAAkC;AACtC;AACA;IACI,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;AACA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,yDAAwC;IACxC,kCAAkC;IAClC,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;;;;;;IAMI,mBAAmB;AACvB;AACA;;;IAGI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;;;IAGI,gBAAgB;AACpB;AACA;;;IAGI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,yDAA4C;IAC5C,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,aAAa;IACb,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;;QAEI,UAAU;QACV,uBAAuB;IAC3B;IACA;;;;QAII,UAAU;IACd;AACJ;AACA;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;AACA;IACI;;QAEI,UAAU;QACV,oBAAoB;QACpB,QAAQ;QACR,YAAY;QACZ,2BAA2B;IAC/B;IACA;;QAEI,UAAU;QACV,uBAAuB;IAC3B;AACJ;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,YAAY;AAChB;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,yDAAmD;AACvD;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,UAAU;IACV,WAAW;IACX,yDAAkD;AACtD;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,MAAM;IACN,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV;;;;;;KAMC;AACL;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,WAAW;AACf;;AAEA;;;;;;;;;;;GAWG;AACH;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;AACA;;;;;;GAMG;AACH;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;;;;;GAKG;AACH;;;;IAII,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,yDAA2C;IAC3C,4BAA4B;IAC5B,sCAAsC;IACtC,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yDAAyC;IACzC,kCAAkC;IAClC,4BAA4B;AAChC;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,MAAM;IACN,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,wGAAwG;AAC5G;;AAEA,oCAAoC;;AAEpC;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;AACf;AACA;IACI,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,mCAAmC;IACnC,qBAAqB;IACrB,sCAAsC;AAC1C;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;;IAEI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;AACA;;IAEI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;IACV,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI;sCACkC;AACtC;AACA;IACI;uCACmC;IACnC,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB;sCACkC;IAClC,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;;;;;;IAMI,wCAAwC;AAC5C;;AAEA;;;;;;;;IAQI;sCACkC;IAClC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;;;QAGI,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI;QACI,oDAAoD;IACxD;IACA;QACI,gEAAgE;IACpE;IACA;QACI;;;;;;;SAOC;IACL;IACA;QACI,mEAAmE;IACvE;IACA;QACI,gEAAgE;IACpE;AACJ;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,OAAO;IACP,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,6CAA6C;IAC7C,oCAAoC;IACpC,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC;;2BAEuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,yBAAyB;IACzB,sBAAsB;IACtB,mCAAmC;IACnC,WAAW;IACX,cAAc;IACd,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;;;QAGI,WAAW;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap');\n* {\n    outline: none !important;\n}\n\n#root {\n    display: flex;\n    min-height: 100vh;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n    user-select: none;\n}\n\nbody {\n    font-family: 'Inter', sans-serif;\n    background-color: #fff;\n    color: #1d253f;\n}\n@media (min-width: 576px) {\n    body {\n        min-height: 100vh;\n        display: flex;\n        flex-direction: column;\n    }\n}\n\na {\n    text-decoration: none !important;\n    transition: 0.3s;\n    color: #1d253f;\n}\na:hover {\n    color: initial;\n    opacity: 0.7;\n}\n\n.btn:focus {\n    box-shadow: none;\n}\n\n.btn-block {\n    width: 100%;\n}\n\n@media (min-width: 1400px) {\n    .container {\n        max-width: 1380px;\n    }\n}\n@media (max-width: 575.98px) {\n    .container {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n\n.row-6 {\n    margin-left: -6px;\n    margin-right: -6px;\n}\n.row-6 > [class*='col'] {\n    padding-left: 6px;\n    padding-right: 6px;\n}\n\n.row-8 {\n    margin-left: -8px;\n    margin-right: -8px;\n}\n.row-8 > [class*='col'] {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.row-10 {\n    margin-left: -10px;\n    margin-right: -10px;\n}\n.row-10 > [class*='col'] {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.form-group {\n    margin-bottom: 16px;\n}\n\n.fz-0 {\n    font-size: 0px !important;\n}\n\n.fz-14 {\n    font-size: 14px !important;\n}\n\n.h1,\nh1 {\n    font-size: 56px;\n    font-weight: 900;\n}\n@media (max-width: 767.98px) {\n    .h1,\n    h1 {\n        font-size: 44px;\n    }\n}\n\n.h1-comment {\n    font-weight: bold;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n}\n\n.h3,\nh3 {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 40px;\n    position: relative;\n}\n.h3 .number,\nh3 .number {\n    position: absolute;\n    color: #6539d9;\n    left: -25px;\n}\n\n.h3 .number.two-digit,\nh3 .number.two-digit {\n    left: -35px;\n}\n\n@media (max-width: 767.98px) {\n    .h3 .number,\n    h3 .number,\n    h3 .number.two-digit {\n        left: 0;\n        top: -30px;\n    }\n}\n\n.h4,\nh4 {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.progress-line {\n    background: #e1e5f0;\n    height: 4px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1030;\n    transition: 0.3s;\n}\n.progress-line:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #440fcf;\n    width: 11%;\n    transition: 0.3s;\n}\n\n.header {\n    padding: 16px 0;\n    margin-bottom: 24px;\n    position: fixed;\n    top: 4px;\n    left: 0;\n    right: 0;\n    background: #fff;\n    z-index: 1030;\n}\n.header .logo img {\n    width: 75px;\n}\n@media (max-width: 575.98px) {\n    .header .logo img {\n        width: 62px;\n    }\n}\n.header .brand {\n    display: inline-flex;\n    font-weight: bold;\n}\n@media (max-width: 575.98px) {\n    .header .brand {\n        font-size: 14px;\n    }\n}\n.header .brand img {\n    width: 32px;\n}\n\n.main-section {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    position: relative;\n    z-index: 1002;\n}\n\n.steps {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: 1030;\n}\n.steps .step-1 {\n    display: flex;\n}\n.steps > [class*='step'] {\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.main-content {\n    padding: 260px 0 120px;\n}\n@media (min-width: 1980px) {\n    .main-content {\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n}\n\n.likely-box {\n    display: flex;\n    margin-bottom: 48px;\n}\n/* @media (max-width: 767.98px) {\n    .likely-box {\n        justify-content: center;\n    }\n} */\n.likely-box .radio-group {\n    display: inline-block;\n    font-size: 14px;\n    position: relative;\n}\n@media (min-width: 768px) {\n    .likely-box .radio-group:not(:last-child) {\n        margin-right: 18px;\n    }\n}\n@media (max-width: 575.98px) {\n    .likely-box .radio-group {\n        flex-grow: 1;\n    }\n}\n.likely-box .radio-group input {\n    display: none;\n}\n.likely-box .radio-group input ~ span {\n    padding: 4px;\n    display: inline-block;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #6539d9;\n    border-radius: 8px;\n    text-align: center;\n    line-height: 28px;\n    color: #6539d9;\n    cursor: pointer;\n}\n@media (max-width: 767.98px) {\n    .likely-box .radio-group input ~ span {\n        border-radius: 0;\n    }\n}\n@media (max-width: 575.98px) {\n    .likely-box .radio-group input ~ span {\n        width: 100%;\n        padding: 2px;\n        font-size: 12px;\n    }\n}\n.likely-box .radio-group input:checked ~ span,\n.likely-box .radio-group input:hover ~ span {\n    transition: 0.3s;\n    background: #6539d9;\n    font-weight: bold;\n    color: #fff;\n}\n@media (max-width: 767.98px) {\n    .likely-box .radio-group:first-child span {\n        border-radius: 6px 0 0 6px;\n    }\n    .likely-box .radio-group:last-child span {\n        border-radius: 0 6px 6px 0;\n    }\n    .likely-box .radio-group:not(:last-child) span {\n        border-right: 0;\n    }\n}\n\n.likely-link {\n    position: absolute;\n    bottom: -36px;\n    cursor: pointer;\n    white-space: nowrap;\n    color: #4e5778;\n}\n.likely-link.link-right {\n    right: 0;\n}\n\n.footer {\n    margin-top: 24px;\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    padding: 20px 0 48px;\n    text-align: center;\n    background: #fff;\n    z-index: 2;\n}\n@media (max-width: 991.98px) {\n    .footer {\n        padding: 20px 0;\n    }\n}\n\n.pagination-box {\n    font-size: 14px;\n}\n.pagination-box .arrows-box {\n    display: inline-block;\n    vertical-align: middle;\n}\n.pagination-box .arrows-box .arrow {\n    display: inline-block;\n    background: #fff;\n    border-radius: 8px;\n    width: 24px;\n    height: 24px;\n    text-align: center;\n    padding: 4px;\n    background: #fff;\n    border: 1px solid #af91ff;\n    transition: 0.3s;\n    line-height: 14px;\n}\n.pagination-box .arrows-box .arrow:hover {\n    background: #440fcf;\n    opacity: 1;\n}\n.pagination-box .arrows-box .arrow:hover svg path {\n    fill: #fff;\n}\n.pagination-box .arrows-box .arrow:disabled {\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n.btn-next {\n    color: #fff;\n    background: #6539d9;\n    border: 0;\n    padding: 10px 34px;\n    transition: 0.3s;\n    font-size: 14px;\n    border-radius: 8px;\n    text-align: center;\n    font-weight: bold;\n}\n@media (max-width: 575.98px) {\n    .btn-next {\n        width: 100%;\n    }\n}\n.btn-next:hover,\n.btn-next:active {\n    opacity: 1;\n    color: #fff !important;\n    background: #440fcf !important;\n}\n.btn-next:disabled {\n    background: #c4c9d9 !important;\n    color: rgba(255, 255, 255, 0.6) !important;\n}\n.btn-next.audio-to-text {\n    padding: 10px 16px;\n    line-height: 22px;\n}\n.btn-next.audio-to-text svg path {\n    fill: #fff !important;\n}\n.btn-next.delete-image-btn {\n    padding: 10px 16px;\n}\n.btn-next.btn-cancel {\n    padding: 10px 16px;\n    border: 1px solid #6539d9;\n    background: #fff;\n    color: #1d253f;\n    font-weight: normal;\n}\n.btn-next.btn-cancel:hover {\n    opacity: 1;\n    color: #fff !important;\n    background: #440fcf !important;\n}\n\n.btn-prev {\n    border: 1px solid #af91ff;\n    padding: 7.5px;\n    transition: 0.3s;\n    border-radius: 8px;\n    width: 41px;\n    height: 41px;\n    line-height: 24px;\n    text-align: center;\n    font-size: 0;\n}\n.btn-prev:hover,\n.btn-prev:active,\n.btn-video:active,\n.btn-video:hover {\n    opacity: 1;\n    color: #fff !important;\n    border-color: #440fcf !important;\n    background: #440fcf !important;\n}\n.btn-prev:hover svg path,\n.btn-prev:active svg path {\n    fill: #fff;\n}\n.btn-video {\n    border: 1px solid #af91ff;\n    padding: 5px 7.5px 5.5px 7.5px;\n    transition: 0.3s;\n    border-radius: 8px;\n    width: auto;\n    height: inherit;\n    line-height: 24px;\n    text-align: center;\n    margin-top: 10px;\n    background-color: transparent;\n}\n\n.copywright {\n    font-size: 14px;\n    color: #4e5778;\n}\n@media (max-width: 575.98px) {\n    .copywright {\n        font-size: 12px;\n    }\n}\n.copywright .link-brand {\n    color: #440fcf;\n}\n\n.form-textarea {\n    height: 220px !important;\n    resize: none;\n    background: #fff;\n    border-radius: 8px;\n    color: #1d253f;\n    border: 1px solid #838bad;\n    font-size: 14px;\n    padding: 12px 16px 40px;\n}\n.form-textarea::-webkit-input-placeholder {\n    color: #838bad;\n}\n.form-textarea::-moz-placeholder {\n    color: #838bad;\n}\n.form-textarea:-ms-input-placeholder {\n    color: #838bad;\n}\n.form-textarea:focus {\n    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);\n    border-color: #838bad;\n}\n\n.generated {\n    font-size: 12px;\n    color: #838bad;\n    position: absolute;\n    bottom: 12px;\n    left: 16px;\n}\n.generated img,\n.generated span {\n    vertical-align: middle;\n}\n\n.the-count-1000 {\n    position: absolute;\n    color: #c4c9d9;\n    bottom: 12px;\n    right: 16px;\n    display: inline-block;\n    font-size: 12px;\n    transition: 0.3s;\n}\n\n.the-count-100 {\n    color: #4e5778;\n    font-size: 12px;\n    text-align: right;\n    position: absolute;\n    right: 0;\n    top: 44px;\n}\n\n.label-store {\n    margin-bottom: 14px;\n    font-size: 14px;\n    color: #4e5778;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.label-agreement {\n    color: #1d253f;\n}\n\ninput[type='checkbox'],\ninput[type='radio'] {\n    display: none;\n}\ninput[type='checkbox'] ~ .f,\ninput[type='radio'] ~ .f {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    border: 1px solid #838bad;\n    border-radius: 100px;\n    position: relative;\n}\ninput[type='checkbox']:checked ~ .f,\ninput[type='radio']:checked ~ .f {\n    transition: 0.3s;\n    background: #6539d9;\n    border-color: #6539d9;\n    color: #6539d9;\n}\ninput[type='checkbox']:checked ~ .f:before,\ninput[type='radio']:checked ~ .f:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\ninput[type='checkbox']:checked ~ .f ~ span,\ninput[type='radio']:checked ~ .f ~ span {\n    font-weight: bold;\n}\n\ninput[type='radio']:checked ~ .f:before {\n    width: 7px;\n    height: 7px;\n    background: #fff;\n    border-radius: 100px;\n}\n\ninput[type='checkbox'] ~ .f {\n    border-radius: 4px;\n}\ninput[type='checkbox']:checked ~ .f:before {\n    width: 16px;\n    height: 16px;\n    background-image: url(../img/check.svg);\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n\n.input-text {\n    font-size: 14px;\n    padding: 8px 16px;\n    border: 1px solid #838bad;\n    border-radius: 8px;\n    height: 40px;\n    color: #1d253f;\n}\n.input-text::-webkit-input-placeholder {\n    color: #7c85a6;\n}\n.input-text::-moz-placeholder {\n    color: #7c85a6;\n}\n.input-text:-ms-input-placeholder {\n    color: #7c85a6;\n}\n.input-text:focus {\n    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);\n    border-color: #838bad;\n}\n.input-text.error {\n    border-color: #ff3e4a;\n}\n\n.label {\n    font-size: 12px;\n    color: #838bad;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 576px) {\n    .input-small {\n        max-width: 280px;\n    }\n}\n\n.datepicker {\n    padding: 8px 16px 8px 30px;\n    cursor: pointer;\n}\n.datepicker:focus ~ svg path {\n    fill: #1d253f;\n}\n\n.img-calendar {\n    position: absolute;\n    top: 50%;\n    left: 8px;\n    transform: translateY(-50%);\n    pointer-events: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.title-feedback {\n    font-weight: 900;\n    font-size: 56px;\n    color: #1d253f;\n    line-height: 1.2;\n}\n@media (max-width: 767.98px) {\n    .title-feedback {\n        font-size: 32px;\n        text-align: center;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .feedback-box {\n        text-align: center;\n    }\n}\n\n.ui-widget {\n    font-family: inherit;\n}\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n    font-family: inherit;\n}\n\n.ui-widget-content {\n    border-color: #838bad !important;\n    border-radius: 8px;\n    padding: 16px;\n    min-width: 280px;\n}\n@media (max-width: 575.98px) {\n    .ui-widget-content {\n        width: calc(100% - 40px);\n    }\n}\n\n.ui-datepicker .ui-state-default {\n    font-size: 14px;\n    background: none;\n    border: none;\n}\n.ui-datepicker .ui-state-default:hover {\n    color: #fff !important;\n    background-color: #6539d9;\n    font-weight: bold;\n    opacity: 1;\n}\n.ui-datepicker td span,\n.ui-datepicker td a {\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    line-height: 30px;\n    border-radius: 5px;\n    text-align: center;\n}\n.ui-datepicker .ui-state-active {\n    color: #fff !important;\n    background-color: #6539d9;\n    font-weight: bold;\n    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);\n}\n.ui-datepicker .ui-state-highlight {\n    color: #1d253f !important;\n    background-color: #fff;\n    border: 1px solid #6539d9;\n    font-weight: bold;\n}\n.ui-datepicker .ui-datepicker-buttonpane {\n    margin: 0;\n}\n.ui-datepicker .ui-datepicker-buttonpane button {\n    margin: 0.5em 0.2em;\n    padding: 0.2em 0.3em;\n    transition: 0.3s;\n}\n.ui-datepicker .ui-datepicker-title {\n    line-height: inherit;\n}\n.ui-datepicker .ui-datepicker-title select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    font-size: 14px;\n    margin: 1px 0;\n    font-weight: bold;\n    border: 0;\n    height: 26px;\n    padding: 1px 10px;\n    cursor: pointer;\n    width: auto;\n    line-height: 1;\n    background-position: calc(100% - 7px) center;\n    background-size: 7px;\n}\n.ui-datepicker .ui-datepicker-title select::-ms-expand {\n    display: none;\n}\n\n.ui-datepicker-header {\n    border: none;\n    border-radius: 0;\n    background: none;\n}\n\n.ui-datepicker-calendar thead th {\n    color: #838bad !important;\n    font-weight: normal !important;\n}\n\n.ui-datepicker-prev,\n.ui-datepicker-next {\n    top: 50% !important;\n    transform: translateY(-50%);\n    border: none !important;\n    background: none !important;\n    cursor: pointer;\n}\n.ui-datepicker-prev span,\n.ui-datepicker-next span {\n    background: none !important;\n    font-size: 12px;\n    transition: 0.3s;\n    width: 6px;\n    height: 10px;\n    margin: 0 !important;\n    transform: translate(-50%, -50%) !important;\n}\n.ui-datepicker-prev span:before,\n.ui-datepicker-next span:before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n\n.ui-datepicker-prev span:before {\n    background-image: url(../img/calendar-left.svg);\n}\n.ui-datepicker-prev:hover span {\n    transform: translateX(-2px);\n}\n\n.ui-datepicker-next span:before {\n    background-image: url(../img/calendar-right.svg);\n}\n.ui-datepicker-next:hover span {\n    transform: translateX(2px);\n}\n\n.select2-container {\n    display: block;\n    width: auto !important;\n    min-width: 140px !important;\n}\n@media (min-width: 576px) {\n    .select2-container {\n        max-width: 280px !important;\n    }\n}\n.select2-container .select2-selection--single {\n    background: #fff;\n    border: 1px solid #838bad;\n    padding-left: 16px;\n    padding-right: 26px;\n    transition: 0.3s;\n    height: 40px;\n}\n.select2-container .select2-selection--single:focus {\n    box-shadow: 0 0 0 0.25rem rgba(68, 15, 207, 0.1);\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n    padding-left: 0;\n    padding-right: 0;\n}\n.select2-container .selection {\n    display: block;\n}\n\n.select2-container--default .select2-selection--single {\n    border-radius: 8px !important;\n}\n.select2-container--default\n    .select2-selection--single\n    .select2-selection__rendered,\n.select2-container--default\n    .select2-selection--single\n    .select2-selection__placeholder {\n    color: #1d253f;\n    line-height: 38px;\n    font-size: 14px;\n}\n.select2-container--default\n    .select2-selection--single\n    .select2-selection__clear {\n    display: none;\n}\n.select2-container--default\n    .select2-selection--single\n    .select2-selection__arrow {\n    height: 5px;\n    width: 8px;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-image: url(../img/arrow-select.svg);\n    background-size: cover;\n}\n.select2-container--default\n    .select2-selection--single\n    .select2-selection__arrow\n    b {\n    display: none;\n}\n\n.select2-container--open .select2-dropdown {\n    border: 1px solid #838bad;\n    border-radius: 8px;\n    overflow: hidden;\n    top: 16px;\n    padding: 0;\n}\n.select2-container--open .select2-dropdown .select2-search--dropdown {\n    display: none;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options {\n    max-height: 100px;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options::-webkit-scrollbar-track {\n    background-color: transparent;\n    border-radius: 2px;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options::-webkit-scrollbar-thumb {\n    background-color: #f2edff;\n    border-radius: 2px;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options\n    .select2-results__option {\n    font-size: 14px;\n    padding: 4px 16px;\n    color: #4e5778;\n    background-color: transparent;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options\n    .select2-results__option--highlighted.select2-results__option--selectable {\n    background: transparent;\n}\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options\n    .select2-results__option--highlighted.select2-results__option--selectable:hover,\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options\n    .select2-results__option--highlighted.select2-results__option--selectable.select2-results__option--selected,\n.select2-container--open\n    .select2-dropdown\n    .select2-results\n    .select2-results__options\n    .select2-results__option--highlighted.select2-results__option--selectable.select2-results__option--highlighted.select2-results__option--selectable {\n    background-color: #f2edff;\n}\n\n.step-2,\n.step-3,\n.step-4,\n.step-5,\n.step-6,\n.step-7,\n.step-8,\n.step-9 {\n    display: none;\n}\n\n.step-2-active .progress-line:before {\n    width: 22.2222222222%;\n}\n.step-2-active .steps .step-1 {\n    display: none;\n}\n.step-2-active .steps .step-2 {\n    display: flex;\n}\n\n.step-3-active .progress-line:before {\n    width: 33.3333333333%;\n}\n.step-3-active .steps .step-2 {\n    display: none;\n}\n.step-3-active .steps .step-3 {\n    display: flex;\n}\n\n.step-4-active .progress-line:before {\n    width: 44.4444444444%;\n}\n.step-4-active .steps .step-3 {\n    display: none;\n}\n.step-4-active .steps .step-4 {\n    display: flex;\n}\n\n.step-5-active .progress-line:before {\n    width: 55.5555555556%;\n}\n.step-5-active .steps .step-4 {\n    display: none;\n}\n.step-5-active .steps .step-5 {\n    display: flex;\n}\n\n.step-6-active .progress-line:before {\n    width: 66.6666666667%;\n}\n.step-6-active .steps .step-5 {\n    display: none;\n}\n.step-6-active .steps .step-6 {\n    display: flex;\n}\n\n.step-7-active .progress-line:before {\n    width: 77.7777777778%;\n}\n.step-7-active .steps .step-6 {\n    display: none;\n}\n.step-7-active .steps .step-7 {\n    display: flex;\n}\n\n.step-8-active .progress-line:before {\n    width: 88.8888888889%;\n}\n.step-8-active .steps .step-7 {\n    display: none;\n}\n.step-8-active .steps .step-8 {\n    display: flex;\n}\n\n.step-9-active .progress-line:before {\n    width: 100%;\n}\n.step-9-active .steps .step-8 {\n    display: none;\n}\n.step-9-active .steps .step-9 {\n    display: flex;\n}\n\n.textarea-box .message {\n    text-align: center;\n    background: #ede7fb;\n    border-radius: 100px;\n    font-size: 10px;\n    padding: 4px 16px;\n    margin-bottom: 16px;\n}\n.textarea-box .message.orange {\n    background: #ffebdc;\n}\n.textarea-box .message.red {\n    background: #ffdcdc;\n}\n\n.dropdown-media .dropdown-toggle {\n    display: inline-block;\n    border: 1px solid #6539d9;\n    border-radius: 8px;\n    padding: 8px 16px;\n    height: 42px;\n    font-size: 14px;\n    line-height: 22px;\n    background: #fff;\n}\n.dropdown-media .dropdown-toggle svg path {\n    transition: 0.3s;\n}\n.dropdown-media .dropdown-toggle:hover {\n    opacity: 1;\n    color: #fff !important;\n    background: #440fcf !important;\n}\n.dropdown-media .dropdown-toggle:hover svg path {\n    fill: #fff;\n}\n.dropdown-media .dropdown-toggle:after {\n    display: none;\n}\n.dropdown-media .dropdown-toggle.show {\n    background: #ede7fb;\n}\n.dropdown-media .dropdown-menu {\n    margin-top: 0;\n    min-width: 100%;\n    border-color: #838bad;\n    border-radius: 8px;\n}\n.dropdown-media .dropdown-menu .dropdown-item {\n    padding: 4px 16px;\n    color: #4e5778;\n    font-size: 14px;\n}\n.dropdown-media .dropdown-menu .dropdown-item:hover,\n.dropdown-media .dropdown-menu .dropdown-item:active,\n.dropdown-media .dropdown-menu .dropdown-item:focus {\n    background-color: #f4f4f5;\n    opacity: 1;\n}\n\n.audio-recording {\n    background: #ede7fb;\n    border-radius: 8px;\n    padding: 12.5px 16px 12.5px 35px;\n    box-sizing: border-box;\n}\n.audio-recording.orange #recordTimeDisplay .limit {\n    color: #ff6b00;\n}\n.audio-recording.red #recordTimeDisplay .limit {\n    color: #ff3e4a;\n}\n\n@media (min-width: 576px) {\n    .audiorecorder > [class*='col']:first-child {\n        border-right: 1px solid #e1e5f0;\n    }\n    .audiorecorder > [class*='col']:last-child {\n        border-left: 1px solid #e1e5f0;\n    }\n}\n\n.btn-delete svg path,\n.btn-transform svg path {\n    transition: 0.3s;\n}\n.btn-delete:hover,\n.btn-transform:hover {\n    opacity: 1;\n}\n.btn-delete:hover svg path,\n.btn-transform:hover svg path {\n    fill: #6539d9;\n}\n\n.btn-record,\n.btn-play,\n.btn-transform,\n.btn-empty-audio,\n.btn-delete {\n    /* width: 20px;\n    height: 20px; */\n    display: inline-block;\n    text-align: center;\n    line-height: 20px;\n    font-size: 0;\n    width: auto;\n    height: auto;\n    border: none;\n    background: none;\n}\n\n.btn-transform:disabled {\n    opacity: 0.5;\n}\n\n#waveform {\n    cursor: pointer;\n}\n\n#recordTimeDisplay,\n#playTimeDisplay {\n    font-size: 14px;\n}\n#recordTimeDisplay span,\n#playTimeDisplay span {\n    font-weight: bold !important;\n}\n\n.range {\n    width: 100%;\n    height: 10px;\n    -webkit-appearance: none;\n    background: #c4c9d9;\n    outline: none;\n    border-radius: 15px;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.range::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #f2edff;\n    box-shadow: -407px 0 0 400px #440fcf;\n}\n\n/* @media (max-width: 575.98px) {\n    .modal-audio.fade .modal-dialog {\n        transform: translate(0, 100%);\n    }\n    .modal-audio.show .modal-dialog {\n        transform: translate(0, 0);\n    }\n    .modal-audio .modal-dialog {\n        margin: auto 0 0 0;\n        min-height: 100vh;\n    }\n} */\n.modal-audio .modal-content {\n    padding: 40px;\n    text-align: center;\n    border: 0;\n}\n/* @media (max-width: 575.98px) {\n    .modal-audio .modal-content {\n        border-radius: 8px 8px 0 0;\n        margin-top: auto;\n    }\n} */\n.modal-audio .modal-content .icon-box {\n    display: flex;\n    position: relative;\n    width: 150px;\n    height: 150px;\n    margin: 0 auto;\n    margin-bottom: 40px;\n}\n.modal-audio .modal-content .icon-box .icon-box-inside {\n    margin: auto;\n    width: 100px;\n    height: 100px;\n    line-height: 100px;\n    background: #f2edff;\n    border-radius: 100px;\n    position: relative;\n    z-index: 3;\n}\n.modal-audio .modal-content .icon-box .icon-box-inside:before,\n.modal-audio .modal-content .icon-box .icon-box-inside:after {\n    content: '';\n    position: absolute;\n    border-radius: 100px;\n    transition: 0.3s;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.modal-audio .modal-content .icon-box .icon-box-inside:before {\n    width: 160px;\n    height: 160px;\n    background: rgba(242, 237, 255, 0.6);\n    z-index: -1;\n    animation: color-point 5s infinite;\n}\n.modal-audio .modal-content .icon-box .icon-box-inside:after {\n    width: 200px;\n    height: 200px;\n    background: rgba(242, 237, 255, 0.4);\n    z-index: 1;\n    animation: color-point 5s infinite;\n}\n\n@keyframes color-point {\n    0% {\n        opacity: 0;\n    }\n    33% {\n        opacity: 0.5;\n    }\n    50% {\n        opacity: 1;\n    }\n    75% {\n        opacity: 0.5;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n.video-recording,\n.video-outer {\n    position: relative;\n}\n\n.video-outer {\n    border: 1px solid #c4c9d9;\n    overflow: hidden;\n    border-radius: 8px;\n    box-sizing: border-box;\n    display: block;\n}\n\n.video-outer .video-delete {\n    z-index: 22;\n}\n\n.video-recording .video-js {\n    /* background: #f2edff; */\n    /* border: 1px solid #c4c9d9; */\n    /* overflow: hidden; */\n    width: 100%;\n    height: inherit;\n}\n.video-recording .video-js .vjs-device-button {\n    background-color: transparent;\n    background-image: url(../img/camera.svg);\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 48px;\n    height: 48px;\n    margin: 0;\n    transform: translate(-50%, -50%);\n}\n.video-recording .video-js .vjs-device-button:before {\n    display: none;\n}\n.video-recording .video-js .vjs-device-button:hover {\n    opacity: 0.8;\n}\n.video-recording .video-js .vjs-control-bar {\n    color: #af91ff;\n    height: auto;\n    background: #fff;\n}\n\n@media (min-width: 576px) {\n    .video-recording .video-js .vjs-control-bar {\n        padding: 16px;\n        font-size: 12px;\n    }\n}\n.video-recording .video-js .vjs-control-bar button {\n    transition: 0.3s;\n}\n.video-recording .video-js .vjs-control-bar button:hover {\n    color: #440fcf;\n}\n.video-recording\n    .video-js\n    .vjs-control-bar\n    .vjs-volume-panel\n    .vjs-volume-control\n    .vjs-volume-level {\n    background: #440fcf;\n}\n.video-recording .video-js .vjs-control-bar .vjs-current-time,\n.video-recording .video-js .vjs-control-bar .vjs-time-divider,\n.video-recording .video-js .vjs-control-bar .vjs-duration {\n    padding-left: 2px;\n    padding-right: 2px;\n    min-width: auto;\n}\n.video-recording .video-js .vjs-control-bar .vjs-play-progress {\n    background: #440fcf;\n}\n\n.video-delete,\n.upload__img-delete,\n.upload__img-play {\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    background: #fff;\n    border-radius: 100px;\n    width: 28px;\n    height: 28px;\n    border: 1px solid #c4c9d9;\n    text-align: center;\n    line-height: 23px;\n    cursor: pointer;\n}\n.video-delete svg path,\n.upload__img-delete svg path,\n.upload__img-play svg path {\n    transition: 0.3s;\n}\n.video-delete:hover svg path,\n.upload__img-delete:hover svg path,\n.upload__img-play:hover svg path {\n    fill: #440fcf;\n}\n\nlabel.error {\n    color: #ff3e4a;\n    font-size: 12px;\n    padding-left: 20px;\n    padding-right: 40px;\n    position: relative;\n}\nlabel.error:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 16px;\n    height: 16px;\n    background-image: url(../img/validation.svg);\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n\n.images-uploading .upload__box .upload__btn-box {\n    border: 1px solid #838bad;\n    border-radius: 8px;\n    text-align: center;\n    overflow: hidden;\n}\n.images-uploading .upload__box .upload__btn-box .upload__inputfile {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    cursor: pointer;\n}\n.images-uploading .upload__box .upload__btn-box .upload__btn {\n    position: relative;\n    transition: 0.3s;\n}\n.images-uploading .upload__box .upload__btn-box .upload__btn:hover {\n    opacity: 0.8;\n}\n.images-uploading .upload__box .upload__btn-box .upload__btn .upload-img {\n    padding: 10px;\n    display: flex;\n    height: 110px;\n}\n.images-uploading .upload__box .upload__btn-box .upload__btn .upload-img img {\n    margin: auto;\n}\n.images-uploading .upload__box .upload__img-box {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n    padding: 0 10px;\n    margin-bottom: 20px;\n    position: relative;\n    text-align: center;\n    order: -1 !important;\n}\n@media (max-width: 575.98px) {\n    .images-uploading .upload__box .upload__img-box {\n        width: 50%;\n    }\n}\n@media (min-width: 1200px) {\n    .images-uploading .upload__box .upload__img-box:hover .upload__img-delete,\n    .images-uploading .upload__box .upload__img-box:hover .upload__img-play {\n        opacity: 1;\n        pointer-events: initial;\n    }\n    .images-uploading\n        .upload__box\n        .upload__img-box:hover\n        .magnific-popup:after {\n        opacity: 1;\n    }\n}\n@media (max-width: 1199.98px) {\n    .images-uploading .upload__box .upload__img-box .upload__img-bottom {\n        background: #ede7fb;\n        height: 36px;\n        border-radius: 0 0 8px 8px;\n    }\n}\n.images-uploading .upload__box .upload__img-box .magnific-popup {\n    height: 110px;\n    position: relative;\n    display: block;\n    border-radius: 8px;\n    border: 1px solid #838bad;\n    overflow: hidden;\n}\n@media (max-width: 1199.98px) {\n    .images-uploading .upload__box .upload__img-box .magnific-popup {\n        border-radius: 8px 8px 0 0;\n    }\n}\n.images-uploading .upload__box .upload__img-box .magnific-popup:after {\n    content: '';\n    position: absolute;\n    transition: 0.3s;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(101, 57, 217, 0.5);\n    opacity: 0;\n}\n.images-uploading .upload__box .upload__img-box .magnific-popup:hover {\n    opacity: 1;\n}\n.images-uploading .upload__box .upload__img-box .magnific-popup .img-bg {\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: cover;\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.images-uploading .upload__box .upload__img-box .upload__img-delete,\n.images-uploading .upload__box .upload__img-box .upload__img-play {\n    top: auto;\n    bottom: 4px;\n    transition: 0.3s;\n}\n@media (min-width: 1200px) {\n    .images-uploading .upload__box .upload__img-box .upload__img-delete,\n    .images-uploading .upload__box .upload__img-box .upload__img-play {\n        opacity: 0;\n        pointer-events: none;\n        top: 50%;\n        bottom: auto;\n        transform: translateY(-50%);\n    }\n    .images-uploading .upload__box .upload__img-box .upload__img-delete:hover,\n    .images-uploading .upload__box .upload__img-box .upload__img-play:hover {\n        opacity: 1;\n        pointer-events: initial;\n    }\n}\n.images-uploading .upload__box .upload__img-box .upload__img-delete {\n    left: 16px;\n}\n.images-uploading .upload__box .upload__img-box .upload__img-play {\n    right: 16px;\n    left: auto;\n}\n\n.mfp-bg {\n    background: #1d253f;\n}\n\n.mfp-container {\n    width: 40%;\n    height: auto;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n@media (max-width: 575.98px) {\n    .mfp-container {\n        width: 100%;\n    }\n}\n.mfp-container .mfp-arrow {\n    background-position: center center;\n    background-repeat: no-repeat;\n    margin-top: 0;\n    width: 24px;\n    height: 24px;\n    transition: 0.3s;\n    top: auto;\n    bottom: 16px;\n}\n.mfp-container .mfp-arrow:before,\n.mfp-container .mfp-arrow:after {\n    display: none !important;\n}\n.mfp-container .mfp-arrow.mfp-arrow-right {\n    right: 24px;\n    background-image: url(../img/arrow-white-right.svg);\n}\n@media (max-width: 575.98px) {\n    .mfp-container .mfp-arrow.mfp-arrow-right {\n        right: 22px;\n    }\n}\n.mfp-container .mfp-arrow.mfp-arrow-left {\n    left: auto;\n    right: 60px;\n    background-image: url(../img/arrow-white-left.svg);\n}\n@media (max-width: 575.98px) {\n    .mfp-container .mfp-arrow.mfp-arrow-left {\n        right: 48px;\n    }\n}\n.mfp-container .mfp-content {\n    border-radius: 8px;\n}\n.mfp-container .mfp-content .mfp-figure:after {\n    top: 0;\n    border-radius: 8px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    position: absolute;\n    z-index: 2;\n    background: linear-gradient(\n        to bottom,\n        #030303 0%,\n        transparent 30%,\n        transparent 70%,\n        #030303 100%\n    );\n}\n.mfp-container .mfp-content .mfp-img {\n    padding: 0;\n    border-radius: 8px;\n}\n.mfp-container .mfp-content .mfp-close {\n    right: 16px;\n    padding: 3px;\n    color: #fff;\n    transition: 0.3s;\n    cursor: pointer !important;\n    width: auto;\n}\n.mfp-container .mfp-content .mfp-bottom-bar {\n    bottom: 0;\n    z-index: 3;\n}\n.mfp-container .mfp-content .mfp-bottom-bar .mfp-counter {\n    left: 24px;\n    right: auto;\n    font-size: 14px;\n    color: #fff;\n}\n\n/* @media (max-width: 575.98px) {\n    .modal-delete.fade .modal-dialog {\n        transform: translate(0, 100%);\n    }\n    .modal-delete.show .modal-dialog {\n        transform: translate(0, 0);\n    }\n    .modal-delete .modal-dialog {\n        margin: auto 0 0 0;\n        min-height: 100vh;\n    }\n} */\n.modal-delete .modal-content {\n    padding: 32px;\n    text-align: center;\n    border: 0;\n}\n/* @media (max-width: 575.98px) {\n    .modal-delete .modal-content {\n        border-radius: 8px 8px 0 0;\n        margin-top: auto;\n        padding: 32px 20px 40px;\n    }\n} */\n.modal-delete .modal-content .icon-box {\n    display: flex;\n    border-radius: 100px;\n    background: #ede7fb;\n    padding: 28px;\n    width: 120px;\n    height: 120px;\n    margin: 0 auto 20px;\n}\n\n.text-capital {\n    text-transform: capitalize;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n}\n.progress-line .progress {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #440fcf;\n    transition: all 0.3s ease 0s;\n}\n.arrow-gap {\n    margin-right: 5px;\n}\n.que-num-gap {\n    margin-right: 4px;\n}\n/* .btn-record {\n\twidth: auto;\n    height: auto;\n\tborder: none;\n    background: none;\n} */\n.btn-record,\n.stop-record,\n.btn-empty-audio,\n.btn-delete {\n    cursor: pointer;\n}\n.video-recording .vjs-control-bar {\n    min-height: 68px !important;\n    /* border: 1px solid #c4c9d9; */\n    border-radius: 0 0 8px 8px;\n    border-top: 0;\n}\n\n.video-preview {\n    /* border-radius: 8px; */\n    width: 100%;\n    height: inherit;\n    /* border: 1px solid #c4c9d9; */\n    overflow: hidden;\n}\n\n.vjs-control-bar button {\n    background: none;\n    border: none;\n    outline: none;\n}\n\n.vjs-control-bar button.start-video,\n.vjs-control-bar button.stop-video,\n.vjs-control-bar button.play-video {\n    width: 48px;\n    cursor: default;\n    text-align: left;\n}\n\n.stop-video-icon,\n.start-video-icon {\n    width: 14px;\n    height: 14px;\n    background-color: rgb(68, 15, 207, 0.5);\n    cursor: pointer;\n    display: inline-block;\n}\n\n.switch-camera svg g {\n    fill: rgb(68, 15, 207, 0.5);\n}\n\n.stop-video-icon:hover,\n.start-video-icon:hover {\n    background-color: rgb(68, 15, 207, 1);\n}\n\n.start-video-icon {\n    border-radius: 100%;\n}\n\n.video-preview video {\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n\n.step-btn-bottom {\n    position: fixed;\n    bottom: 52px;\n}\n.select-input {\n    background-image: url(img/arrow-select.svg);\n    background-repeat: no-repeat;\n    background-position: center right 12px;\n    background-size: 8px;\n}\n.form-control {\n    font-size: 14px;\n    color: #1d253f;\n}\n.error-message {\n    color: #ff3e4a;\n    font-size: 12px;\n    position: relative;\n    padding-left: 20px;\n    font-weight: 400;\n    margin-top: 5px;\n}\n\n.error-message.textarea-validation {\n    margin-top: 0;\n    left: 16px;\n    display: inline-block;\n    bottom: 12px;\n    position: absolute;\n}\n\n.error-message::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -1px;\n    width: 16px;\n    height: 16px;\n    background-image: url(img/validation.svg);\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n.img-bg img {\n    width: 100%;\n}\n.modal.show {\n    display: block;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n.contact-step {\n    position: absolute;\n    left: -35px !important;\n}\n.contact-form label {\n    font-size: 12px;\n    color: #838bad;\n    margin-bottom: 8px;\n    width: 100%;\n}\n.contact-form label span.agree-policy {\n    font-size: 14px;\n    color: #1d253f;\n    position: relative;\n    top: 2px;\n    padding-left: 5px;\n    width: calc(100% - 25px);\n}\n.image-gallery {\n    background-color: #000;\n}\n\n.image-gallery-slide img {\n    border: 2px solid #fff;\n    border-radius: 8px;\n}\n\n.image-gallery-slide::after {\n    content: '';\n    display: block;\n    width: auto;\n    height: auto;\n    /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.6); */\n    top: 0;\n    border-radius: 8px;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    position: absolute;\n    z-index: 2;\n    /* background: linear-gradient(to bottom, #030303 0%, transparent 30%, transparent 70%, #030303 100%); */\n}\n\n/*# sourceMappingURL=style.css.map */\n\n.thumbnail-list {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.thumbnail-list img {\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n}\n\n.gallery-wrapper {\n    position: relative;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    padding: 10px;\n    font-size: 20px;\n    cursor: pointer;\n    z-index: 10;\n}\n.image-gallery {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1043;\n    position: fixed;\n    outline: none !important;\n    -webkit-backface-visibility: hidden;\n    overflow: hidden auto;\n    background-color: rgb(29, 37, 63, 0.8);\n}\n.image-gallery-content {\n    max-width: 40%;\n    min-width: 100px;\n    width: auto;\n    height: auto;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    position: absolute;\n    padding: 0 8px;\n    box-sizing: border-box;\n}\n.image-gallery-slide img {\n    border: 0px;\n    width: inherit !important;\n}\n.image-gallery .image-gallery-icon {\n    background-position: center center;\n    background-repeat: no-repeat;\n    margin-top: 0;\n    width: 24px;\n    height: 24px;\n    transition: 0.3s;\n    top: auto;\n    bottom: 0;\n    padding: 0;\n    background-color: #222;\n}\n.image-gallery .image-gallery-left-nav {\n    left: auto;\n    right: 48px;\n}\n.image-gallery .image-gallery-right-nav {\n    right: 15px;\n}\n.image-gallery-left-nav .image-gallery-svg,\n.image-gallery-right-nav .image-gallery-svg {\n    width: 24px;\n    height: 24px;\n}\n.image-gallery-slide {\n    border-radius: 8px;\n    overflow: hidden;\n}\n.image-gallery .close-button {\n    right: 15px;\n    top: 15px;\n    padding: 3px;\n    color: #fff;\n    transition: 0.3s;\n    cursor: pointer !important;\n    width: auto;\n    background: #222;\n    font-size: 21px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.image-gallery-icon:hover {\n    color: #fff;\n}\n\n@media screen and (max-width: 767px) {\n    .contact-step {\n        left: 0 !important;\n    }\n    .image-gallery-content {\n        max-width: 60%;\n    }\n}\n\n.audio-recording .audio-recorder {\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0px;\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n.audio-recording .audio-recorder-mic,\n.audio-recording .audio-recorder-options {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.audio-recording .audio-recorder-mic {\n    order: 1;\n}\n.audio-recording img[data-testid='ar_pause'].audio-recorder-options {\n    padding-right: 0;\n    display: none;\n}\n.audio-recording img[data-testid='ar_cancel'].audio-recorder-options {\n    padding-right: 0;\n    width: 22px;\n    display: none;\n}\n.outer-audio .btn-delete {\n    border: 0;\n    padding: 0;\n    background-color: transparent;\n}\n.outer-audio .audio-creating {\n    position: relative;\n}\n.audio-creating .btn-delete {\n    position: absolute;\n    top: 10px;\n    left: 16px;\n}\n.audio-recorder-svg-color {\n    filter: invert(15%) sepia(85%) saturate(4708%) hue-rotate(257deg)\n        brightness(76%) contrast(120%);\n}\n.audio-recorder-svg-color-red {\n    filter: invert(18%) sepia(96%) saturate(7500%) hue-rotate(1deg)\n        brightness(105%) contrast(114%);\n    padding-right: 0;\n}\n.audio-recorder-svg-color-red.mic {\n    position: relative;\n    right: 32px;\n    pointer-events: none;\n    filter: invert(30%) sepia(6%) saturate(6%) hue-rotate(337deg)\n        brightness(101%) contrast(87%);\n    cursor: not-allowed;\n    padding-left: 0;\n    border-radius: 0px;\n    opacity: 0;\n}\n\n.preview-title {\n    font-size: 18px;\n    margin: 10px 0;\n}\n.inner-preview {\n    width: calc(100% - 115px);\n    margin-left: 8px;\n    position: absolute;\n    top: 4px;\n    height: 33px;\n}\n.outer-audio .sendSpeech {\n    border: 0;\n    position: absolute;\n    right: 20px;\n    top: 10px;\n    background-color: transparent;\n    width: 24px;\n    padding-right: 0;\n}\naudio::-webkit-media-controls-panel,\naudio::-webkit-media-controls-enclosure,\naudio::-webkit-media-controls-play-button,\naudio,\naudio::-webkit-media-controls-rewind-button,\naudio::-webkit-media-controls-return-to-realtime-button {\n    background-color: transparent !important;\n}\n\naudio::-webkit-media-controls-play-button,\naudio::-webkit-media-controls-pause-button,\naudio::-webkit-media-controls-mute-button,\naudio::-webkit-media-controls-volume-slider-container,\naudio::-webkit-media-controls-volume-slider,\naudio::-webkit-media-controls-current-time-display,\naudio::-webkit-media-controls-time-remaining-display,\naudio::-webkit-media-controls-timeline {\n    filter: invert(15%) sepia(85%) saturate(4708%) hue-rotate(257deg)\n        brightness(76%) contrast(120%);\n    box-shadow: none !important;\n    text-shadow: none !important;\n}\n\nform.main-form-new {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n.contact-form span.agree-policy,\n.contact-form span.agree-policy a {\n    font-weight: 400 !important;\n}\n\n.data-policy {\n    color: #6539d9;\n}\n\n@media (max-width: 768px) {\n    input,\n    textarea,\n    select {\n        font-size: 16px !important;\n    }\n    .myVideo-dimensions {\n        width: 100%;\n        max-width: 100%;\n        min-height: 250px;\n        height: 0;\n        padding-top: 56.25%;\n    }\n}\n\n.loader {\n    width: 75px;\n    aspect-ratio: 1;\n    border: 8px solid #ddd;\n    border-radius: 50%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.loader::before {\n    content: '';\n    position: absolute;\n    inset: -8px;\n    border-radius: 50%;\n    border: 8px solid #440fcf;\n    animation: loader 2s infinite linear;\n}\n@keyframes loader {\n    0% {\n        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n    }\n    25% {\n        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n    }\n    50% {\n        clip-path: polygon(\n            50% 50%,\n            0 0,\n            100% 0,\n            100% 100%,\n            100% 100%,\n            100% 100%\n        );\n    }\n    75% {\n        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n    }\n    100% {\n        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n    }\n}\n.overlay-loader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n.outer-loader {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    margin-left: -30px;\n    width: 100%;\n    height: 100%;\n}\n\n@-moz-document url-prefix() {\n    .range {\n        -webkit-appearance: auto;\n    }\n}\n.media-attached {\n    font-size: 12px;\n    color: #4e5778;\n    margin-top: 5px;\n    text-align: center;\n    padding: 0 12px;\n}\n\n.speech-controller {\n    position: absolute;\n    width: calc(100% - 2px);\n    bottom: 1px;\n    left: 1px;\n    z-index: 2;\n    background: #fff;\n    height: 40px;\n    border-radius: 0 0 8px 8px;\n}\n.label-store.label-agreement .align-middle {\n    position: relative;\n    top: 2px;\n}\n\n.question-header {\n    position: fixed;\n    top: 60px;\n    width: 100%;\n    left: 0;\n    background-color: #fff;\n    z-index: 1030;\n}\n.row.flex-grow-1 {\n    align-items: flex-start;\n}\n\n.mobile-question-head {\n    padding-top: 115px;\n}\n\nvideo.vjs-tech {\n    width: 100%;\n}\n.vjs-control-bar {\n    padding: 16px;\n    font-size: 12px;\n    color: #af91ff;\n    height: auto;\n    background: #fff;\n    display: flex;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.left-icons {\n    display: flex;\n}\n\n.play-video-icon {\n    width: 0;\n    height: 0;\n    border-top: 7px solid transparent;\n    border-left: 12px solid rgb(68, 15, 207, 0.5);\n    border-bottom: 7px solid transparent;\n    cursor: pointer;\n    position: relative;\n    top: -1px;\n}\n\n.play-video-icon:hover {\n    border-left-color: #440fcf;\n}\n\n.switch-camera {\n    display: none;\n}\nbutton.full-screen:hover svg path {\n    fill: #440fcf;\n}\n.vjs-record-indicator {\n    width: 8px;\n    height: 8px;\n    background-color: #ff625e;\n    border-radius: 50%;\n    right: 2.5ex;\n    top: 2ex;\n    position: absolute;\n    opacity: 1;\n    transform: rotateX(0) scale(1.3);\n    transition:\n        all 0.5s,\n        transform 0.2s 0.1s;\n}\n.vjs-record-indicator::before {\n    content: 'REC';\n    color: #fff;\n    position: absolute;\n    left: -2.7em;\n    font-family: Helvetica, sans-serif;\n    animation-name: pulsetext;\n    animation-duration: 5s;\n    animation-iteration-count: infinite;\n    top: -0.1em;\n    font-size: 8px;\n    opacity: 0.6;\n    transition: opacity 0.5s 0.2s;\n}\n\n.vjs-record-indicator::after {\n    content: '';\n    display: block;\n    height: calc(0.8em - 4px);\n    width: calc(0.8em - 4px);\n    border: 2px solid #ff625e;\n    border-radius: 50%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform-origin: center;\n    animation-name: pulse;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-delay: 0.25s;\n}\n\n.vjs-record-indicator:hover::before {\n    text-shadow: 0 0 1em #fff;\n}\n\n.vjs-control-bar.h-68 {\n    height: 68px;\n}\n\n.right-icons {\n    display: flex;\n    align-items: center;\n}\n\n.video-controls {\n    display: flex;\n    align-items: center;\n}\n\n.volume-icon {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 24px;\n    margin-right: 10px;\n}\n\n.play-controls svg path {\n    fill: rgb(68, 15, 207, 0.5);\n}\n.play-controls svg:hover path {\n    fill: rgb(68, 15, 207, 1);\n}\n.play-controls {\n    display: flex;\n    align-items: center;\n    margin-right: 15px;\n}\n\n.volume-range {\n    width: 80px;\n    height: 5px;\n}\n\n.timer {\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width: 1024px) {\n    .switch-camera {\n        display: block;\n    }\n}\n@media (max-width: 844px) {\n    .volume-range {\n        width: 48px;\n    }\n    .left-icons button.start-video,\n    .left-icons button.stop-video,\n    .left-icons button.play-video {\n        width: 35px;\n    }\n}\n\n.btn-border {\n    border: 1px solid #af91ff !important;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
